
import NrButton from '@nextrequestco/components/src/components/NrButton/nr-button.vue'
import NrIcon from '@nextrequestco/components/src/components/NrIcon/NrIcon.vue'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import { createPopper } from '@popperjs/core/lib/popper-lite'

export default {
  components: {
    NrButton,
    NrIcon,
    NrIconButton
  },

  data() {
    return { popper: null, show: false }
  },

  mounted() {
    this.popper = createPopper(this.$refs.trigger.$el, this.$refs.dropdown, {
      strategy: 'fixed',
      placement: 'left-start'
    })
    document.addEventListener('click', this.handleClick)
  },

  methods: {
    handleClick(event: Event): void {
      // Bind a click event to the DOM to track when the ellipsis button is clicked to open or close the menu
      // Also tracks when you click anywhere outside the button to close the menu
      const el = event.target
      const button = this.$refs.trigger.$el

      if (button.contains(el)) {
        this.show = !this.show
      } else {
        this.show = false
      }
    }
  },

  updated() {
    this.popper?.update()
  },

  beforeUnmount() {
    this.popper?.destroy()
    document.removeEventListener('click', this.handleClick)
  }
}
